<template>
  <a-layout>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      :keyboard-config="{isArrow: true}"
      align="center"
      ref="table"
      :data="data"
      :loading="loading"
      keep-source
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      :scroll-x="{enabled: true}"
      :height="height"
      size="mini"
      @cell-click="({row})=>click(row)">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="owner.name" title="business.label.ownerName" width="120"/>
      <vxe-column :formatter="({row})=>getStrings(row.logicalStores,'name')" field="logicalStores" title="business.label.logicalStore"/>
      <vxe-column :formatter="({row})=>getStrings(row.itemCategories,'name')" field="itemCategories" title="business.label.itemCategory"/>
    </vxe-table>
  </a-layout>
</template>

<script>
import { findAll } from '@/api/Api'
import { getStrings } from '@/utils/util'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'MaintenanceConfigTable',
  data() {
    return {
      loading: false,
      data: [],
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.35)
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getStrings,
    getData() {
      this.loading = true
      findAll('maintenanceConfigFactory').then(res => {
        if (res.success) {
          this.data = res.result
        }
      }).finally(() => {
        this.loading = false
      })
    },
    click(row) {
      this.$emit('click', row)
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    }
  }
}
</script>